<app-bread-crumb [items]="[{text:  'socios',link:'/admin/members'},{text:pageTitle}]"
    [sectionTitle]="pageTitle"></app-bread-crumb>

<section class="content">

    <!-- inicio do formulário -->
    <form [formGroup]="objectForm" (ngSubmit)="submitForm()" novalidate>

        <!-- inicio do box -->
        <ng-box [boxIcon]="'fa fa-users'" [boxTitle]="'Dados do Sócio'" [showBoxFooter]="true">


            <!-- cabesalho -->
            <ng-container class="ng-box-header">
                <ng-button (click)="back()" [button]="{name:'back',faIconClass:'fa fa-arrow-left',color:'secondary'}"></ng-button>
            </ng-container>

            <!-- fim do conteudo -->
            <ng-container class="ng-box-content">

                <div class="row">

                    <div class="col-md-6">

                        <div class="form-group">

                            <app-input label="Nome(*)" errorMessage="Campo obrigatório">
                                <input type="text" formControlName="name" class="form-control">
                            </app-input>

                        </div>

                    </div>

                    <div class="col-md-6">

                        <div class="form-group">

                            <app-input label="Número do Sócio(*)"
                                errorMessage="- Campo obrigatório; - Somente números são aceites">
                                <input type="text" formControlName="member_number" class="form-control">
                            </app-input>

                        </div>

                    </div>

                </div>

                <div class="row">

                    <div class="col-md-4">

                        <div class="form-group">

                            <app-input label="Tipo de Sócio(*)" errorMessage="Campo obrigatório">

                                <select formControlName="member_type" class="form-control">
                                    <option value="Simpatizante">Simpatizante</option>
                                    <option value="Socio">Sócio</option>
                                </select>
                            </app-input>

                        </div>

                    </div>
                    <div class="col-md-4">

                        <div class="form-group">

                            <app-input label="Tipo de Documento(*)" errorMessage="Campo obrigatório">

                                <select formControlName="documents_id" class="form-control">
                                    <option *ngFor="let document of documents" [value]="document.id">{{document.name}}</option>
                                </select>
                            </app-input>

                        </div>

                    </div>

                    <div class="col-md-4">

                        <div class="form-group">

                            <app-input label="Nº do Documento de Indentificação(*)"
                                errorMessage="- Campo obrigatório; - Introduza um documento válido;">
                                <input type="text" formControlName="document_number" class="form-control">
                            </app-input>

                        </div>

                    </div>

                </div>

                <div class="row">

                    <div class="col-md-4">

                        <div class="form-group">

                            <app-input label="Provincia(*)" errorMessage="Campo obrigatório">

                                <select formControlName="cities_id" class="form-control">
                                    <option *ngFor="let city of cities" [value]="city.id">{{city.name}}</option>
                                </select>

                            </app-input>

                        </div>

                    </div>

                    <div class="col-md-4">

                        <div class="form-group">

                            <app-input label="Clube(*)" errorMessage="Campo obrigatório">

                                <select formControlName="clubs_id" class="form-control" #iptSelected
                                    (change)="clubQuotas(iptSelected.value)">

                                    <option value="">Selecione o Clube</option>

                                    <ng-container *ngIf="isManagerOrUserClub();else template">
                                        <option [value]="auth?.user?.clubs_id">{{auth?.user?.club?.name}}</option>
                                    </ng-container>

                                    <ng-template #template>
                                        <option *ngFor="let club of clubs" [value]="club.id">{{ club.name }}</option>
                                    </ng-template>
                                </select>

                            </app-input>

                        </div>

                    </div>


                    <div class="col-md-4">

                        <div class="form-group">

                            <app-input label="Quota a Pagar(*)" errorMessage="Campo obrigatório">

                                <select formControlName="quotas_id" class="form-control">

                                        <option value="">Escolha a quota</option>
                                        <option *ngFor="let quota of club?.quotas" [value]="quota.id">
                                            {{ quota.quota_description }}
                                        </option>

                                </select>

                            </app-input>

                        </div>


                    </div>

                </div>

                <fieldset>
                    <legend>Dados de Contacto</legend>
                </fieldset>

                <div class="row">

                    <div class="col-md-4">

                        <div class="form-group">

                            <app-input label="Telefone(*)"
                                errorMessage="- Campo obrigatório;- Introduza um telefone válido;- Mínimo 9 Dígitos, Maxímo 14 Dígitos;">
                                <input type="text" formControlName="phone" class="form-control">
                            </app-input>

                        </div>

                    </div>
                    <div class="col-md-4">

                        <div class="form-group">

                            <app-input label="Email(*)"
                                errorMessage="- Campo obrigatório; - Introduza um email válido;">
                                <input type="text" formControlName="email" class="form-control">
                            </app-input>

                        </div>

                    </div>

                    <div class="col-md-4">

                        <div class="form-group">

                            <app-input label="Endereço(*)" errorMessage="Campo obrigatório">
                                <input type="text" formControlName="address" class="form-control">
                            </app-input>

                        </div>

                    </div>

                </div>

            </ng-container>
            <!-- fim do conteudo -->
            <!-- inicio do footer -->
            <ng-container class="ng-box-footer">
                <div class="row">
                    <div class="col-xs-12">

                        <ng-button  *ngIf="(isAdminOrManager() || isUserKhuzela()) && currentAction==='new'"  class="pull-right" [button]="{
                            name:'salvar',
                            color:'danger',
                            faIconClass:'fa fa-save',
                            type:'submit',
                            loadingText:'SALVANDO',
                            isLoading:isButtonLoading,
                            isDisabled:isButtonLoading || objectForm.invalid}">
                        </ng-button>

                        <ng-button  *ngIf="isAll() && currentAction==='edit'"  class="pull-right" [button]="{
                            name:'salvar',
                            color:'danger',
                            faIconClass:'fa fa-save',
                            type:'submit',
                            loadingText:'SALVANDO',
                            isLoading:isButtonLoading,
                            isDisabled:isButtonLoading || objectForm.invalid}">
                        </ng-button>

                    </div>
                </div>

            </ng-container>
            <!-- fim do footer -->
        </ng-box>
        <!-- fim do box -->

    </form>
    <!-- fim do formulario -->
</section>
